/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Overwrite_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Project \"{name}\" overwritten successfully" |
*
* @param {Explorer_Info_Overwrite_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_overwrite_success_toast = /** @type {((inputs: Explorer_Info_Overwrite_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Overwrite_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Projet "${i?.name}" ecrase avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt "${i?.name}" erfolgreich überschrieben`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Progetto "${i?.name}" sovrascritto con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Проект "${i?.name}" успешно перезаписан.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El proyecto "${i?.name}" se sobrescribió correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目“${i?.name}”已成功覆盖`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクト「${i?.name}」が正常に上書きされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट "${i?.name}" सफलतापूर्वक ओवरराइट हो गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O projeto "${i?.name}" foi sobrescrito com sucesso.`)
	return /** @type {LocalizedString} */ (`Project "${i?.name}" overwritten successfully`)
});